<template>
  <div class="txtPro" style="">
    <el-tooltip :disabled="!isTooltip||!(isOver)" placement="top-start" popper-class="el-tooltip-popper-max-width">
      <template #content>
        <div>{{ name| empty }}</div>
      </template>
      <div v-if="length==0" class='txtcontent defaultStyle' :style="{width:(width==0?'auto':width+'px')}" >
        <span class="defaultStyle" ref="contentObj">{{ name| empty }}</span>
      </div>
      <div v-else class='txtcontent defaultStyle' :style="{width:'auto'}" >
        <span class="defaultStyle" ref="contentObj">{{trun(name)}}</span>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props:{
      width:{
        type:[Number,String],
        default:0
      },
      name:{
        type:String,
        default:""
      },
      length:{
        type:Number,
        default:0
      },
      isTooltip:{
        type:Boolean,
        default:true
      },
    },
    data() {
      return {
        isOver:false,
      };
    },
    computed: {

    },
    methods: {
      trun(value){
        if (value==null||value==undefined||value==="undefined"||value==="null"||value=== " ") return '--';
        if(this.length!=0){
          if(value.length>this.length) this.isOver=true;
          return value.length>this.length?(value.substring(0,this.length))+"...":value
        }
        return value
      }
    },
    created(){

    },
    mounted() {
      if (this.length==0){
        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        var that = this;
        erd.listenTo(this.$refs.contentObj, function(element) {
          var chwidth = element.offsetWidth;
          that.isOver = chwidth>that.width
        });
      }
    },
    filters: {
      empty: function (value) {
        if (value==null||value==undefined||value==="undefined"||value==="null"||value=== "") return '--';
        return value
      }
    }
  };
</script>
<style scoped lang='less'>
.txtPro{
  display: inline-block;
  .txtcontent{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .defaultStyle:focus{
    outline: none;
  }

}



</style>
